import { render, staticRenderFns } from "./order-type-select.vue?vue&type=template&id=03d61eb4&scoped=true&"
import script from "./order-type-select.vue?vue&type=script&lang=js&"
export * from "./order-type-select.vue?vue&type=script&lang=js&"
import style0 from "./order-type-select.vue?vue&type=style&index=0&id=03d61eb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d61eb4",
  null
  
)

export default component.exports